import { Avatar } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
const colorMap = {
    primary: {
        backgroundColor: themeColors.accent.blue.subtlest,
        color: themeColors.accent.blue.base,
    },
    warning: {
        backgroundColor: themeColors.accent.orange.subtlest,
        color: themeColors.accent.orange.base,
    },
    error: {
        backgroundColor: themeColors.accent.red.subtlest,
        color: themeColors.accent.red.base,
    },
    success: {
        backgroundColor: themeColors.accent.green.subtlest,
        color: themeColors.accent.green.base,
    },
    disabled: {
        backgroundColor: themeColors.accent.grey.subtlest,
        color: themeColors.accent.grey.base,
    },
};
export const IconPlaceholder = (props) => {
    return (React.createElement(Avatar, { sx: Object.assign({}, colorMap[props.status]) }, props.children));
};
